import React from 'react';
import { ArrowRight, Beaker, Pill, Activity } from 'lucide-react'; // Optional: for icons
import Thyrocareimg from '../assets/Thyrocare.jpg';
import { useNavigate } from "react-router-dom";
const Thyrocare = () => {
  
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate("/packages");
  };

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      {/* Hero Section */}
      <div className="max-w-8xl mx-auto px-5 py-12 flex flex-col items-center">
        
        {/* Clickable Image / Logo Container */}
    

        {/* Text Content */}
        <div className="text-center max-w-3xl space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 tracking-tight">
            Your Complete <span className="text-red-500">Healthcare</span> Ecosystem
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed">
            We have partnered with <strong>PharmEasy</strong> and <strong>Thyrocare</strong> to bring world-class diagnostic testing, specialized wellness, and seamless medicine delivery right to your doorstep.
          </p>
    <div 
          onClick={handleNavigation}
          className="cursor-pointer transition-transform duration-300 hover:scale-105 mb-10"
        >
          <img 
            src={Thyrocareimg} 
            alt="Thyrocare, Eveya, and PharmEasy Partnership" 
            className="w-full max-w-2xl drop-shadow-xl rounded-2xl" 
          />
        </div>
          {/* Features/Services */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 py-10">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col items-center">
              <div className="bg-red-100 p-3 rounded-full mb-4">
                <Beaker className="text-red-600 w-6 h-6" />
              </div>
              <h3 className="font-semibold text-gray-800">Advanced Diagnostics</h3>
              <p className="text-sm text-gray-500 mt-2">NABL certified lab tests by Thyrocare.</p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col items-center">
              <div className="bg-purple-100 p-3 rounded-full mb-4">
                <Activity className="text-purple-600 w-6 h-6" />
              </div>
              <h3 className="font-semibold text-gray-800">Holistic Wellness</h3>
              <p className="text-sm text-gray-500 mt-2">Specialized care for women & families via Eveya.</p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col items-center">
              <div className="bg-teal-100 p-3 rounded-full mb-4">
                <Pill className="text-teal-600 w-6 h-6" />
              </div>
              <h3 className="font-semibold text-gray-800">Medicine Delivery</h3>
              <p className="text-sm text-gray-500 mt-2">Quick and reliable pharmacy via PharmEasy.</p>
            </div>
          </div>

     
        </div>
      </div>
      
     
    </div>
  );
};

export default Thyrocare;